<template>
  <header class="header">
    <div class="ms-CommandButton ms-CommandButton--noLabel ms-CommandBar-overflowButton">
      <button class="ms-CommandButton-button" style="height: 36px; padding: 0 6px;">
        <span class="ms-CommandButton-icon" style="font-size: 12px !important;"><i class="ms-Icon ms-Icon--MoreVertical"></i></span>
      </button>
      <ul class="ms-ContextualMenu ms-ContextualMenu--hasIcons is-open">
        <li class="ms-ContextualMenu-item">
          <a class="ms-ContextualMenu-link" tabindex="1" @click.stop="goToFeedback">Feedback</a>
          <i class="ms-Icon ms-Icon--Info"></i>
        </li>
        <li class="ms-ContextualMenu-item">
          <a class="ms-ContextualMenu-link" tabindex="1" @click.stop="logout">Log out</a>
          <i class="ms-Icon ms-Icon--FollowUser"></i>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import httpClient from '@/utils/httpClient';

export default {
  mounted() {
    var CommandButtonElements = this.$el.querySelectorAll('.ms-CommandButton');
    for (var i = 0; i < CommandButtonElements.length; i++) {
      new fabric['CommandButton'](CommandButtonElements[i]);
    }
  },
  methods: {
    async goToFeedback(e) {
      const menu = e?.target?.closest('.ms-ContextualHost');

      if (menu) {
        menu.classList.remove('is-open');
      }

      const lock = this.$lock();
      this.$trackEvent('Help');
      const url = await httpClient.get('/api/feedback/canny/redirectUrl');
      window.open(url, '_blank');
      lock.release();
    },
    async logout() {
      const lock = this.$lock();
      this.$trackEvent('Logout');
      await this.$store.dispatch('identity/logout');
      window.location.reload();
      lock.release();
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  right: 1rem;
  top: 0.5rem;
  z-index: 1;
}
</style>
